var map = {
	"./all-1.png": 5496,
	"./all-10.png": 2298,
	"./all-2.png": 9987,
	"./all-3.png": 4778,
	"./all-4.png": 9445,
	"./all-5.png": 6380,
	"./all-6.png": 663,
	"./all-7.png": 7646,
	"./all-8.png": 7033,
	"./all-9.png": 128
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8744;